








import {Component, Inject, Ref, Vue} from "vue-property-decorator";
import UserService from "../services/UserService";
import GlobalEventBus from "../mixins/GlobalEventBus";

@Component
export default class RocketChat extends Vue {

  @Ref()
  // @ts-ignore
  private rocketChatIframe;

  @Inject()
  // @ts-ignore
  private userService: UserService;

  public loading = true;

  mounted() {
    GlobalEventBus.$on('updated-auth', this.auth);
  }

  iframeLoaded() {
    this.auth();
  }

  get url() {
    // @ts-ignore
    return window.ROCKET_CHAT_URL;
  }

  auth() {
    this.loading = true;
    this.userService.rocketAuth().then(response => {
      this.rocketChatIframe.contentWindow.postMessage({
        externalCommand: 'login-with-token',
        token: response.data.authToken
      }, '*');
      this.loading = false;
    });
  }
}
